<template>
  <div>
<!--    <div-->
<!--      class="uppercase text-lightblue  tracking-wider mt-6 font-open-sans text-3xl"-->
<!--    >-->
<!--      Date-->
<!--    </div>-->
<!--    <div-->
<!--      class="mt-4 flex items-center justify-center text-3xl leading-none font-extrabold text-gray-900"-->
<!--    >-->
<!--      <span>{{ sessionDate }}</span>-->
<!--    </div>-->
<!--    <div-->
<!--      class="uppercase text-lightblue  tracking-wider mt-6 font-open-sans text-3xl"-->
<!--    >-->
<!--      Time-->
<!--    </div>-->
<!--    <div-->
<!--      class="mt-4 flex items-center justify-center text-3xl leading-none font-extrabold text-gray-900"-->
<!--    >-->
<!--      <span> {{ friendlyStart }} - {{ friendlyEnd }} </span>-->
<!--    </div>-->
    <div>
      <speaker-side-bar
        v-for="(speaker,idx) in session.speakers"
        :speaker="speaker"
        :key="idx"
      ></speaker-side-bar>
    </div>
  </div>
</template>

<script>
import SpeakerSideBar from "./SpeakerSideBar";

export default {
  name: "DetailsSideBar",
  components: { SpeakerSideBar },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    friendlyStart() {
      const startTime = new Date(this.session.startTime);
      const friendlyStart = startTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
      return friendlyStart;
    },
    friendlyEnd() {
      const endTime = new Date(this.session.endTime);
      const friendlyEnd = endTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
      return friendlyEnd;
    },
    sessionDate() {
      const startDate = new Date(this.session.startTime);
      return startDate.toLocaleDateString([], {
        month: "short",
        day: "numeric"
      });
    }
  }
};
</script>

<style scoped></style>
